import { useEffect, useState } from 'react';

import { apiConnector } from '@/api/api.connector';
import {
  connectLeasingSocket,
  disconnectLeasingSocket
} from '@/integrations/socket.connector';
import { MainLoader } from '@/shared/ui';
import { isInWebView } from '@/shared/webview/env';
import { useAppDispatch, useAppSelector } from '@/store';
import { getDashboardData } from '@/store/leasing.slice';

const TOKEN_REFRESH_INTERVAL_MS = 180000;

const AuthorizedProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const dispatch = useAppDispatch();
  const { dashboardData } = useAppSelector((state) => state.leasing);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      if (!dashboardData) {
        await dispatch(getDashboardData());
      }
      setIsLoading(false);
    })();

    connectLeasingSocket(dispatch);

    let refreshInterval: ReturnType<typeof setInterval> | null = null;
    if (!isInWebView()) {
      refreshInterval = setInterval(async () => {
        await apiConnector.refreshToken();
      }, TOKEN_REFRESH_INTERVAL_MS);
    }

    return () => {
      if (refreshInterval) clearInterval(refreshInterval);
      disconnectLeasingSocket();
    };
  }, []);

  return isLoading ? <MainLoader fullScreen /> : children;
};

export default AuthorizedProvider;
